import type { Image as ImageType } from 'types/capi/shared';

import Tracked from '~/components/Tracked';
import gtm from '~/services/gtm.client';

import { authButtonClassName } from '../AuthDialog';
import AuthPanel from '../AuthPanel';
import ExitNotificationDialog from './ExitNotificationDialog';

type Props = {
  image?: ImageType;
  onCancel: () => void;
  onGoBack: () => void;
};

export default function CancelNotifications({
  image,
  onGoBack,
  onCancel
}: Props) {
  function handleBackgroundDismiss() {
    gtm.trackedButtonClick({
      buttonName: 'CANCEL_NOTIFICATIONS',
      pagePosition: 'Cancel modal'
    });
    onCancel();
  }

  return (
    <ExitNotificationDialog
      heading="Cancel notifications?"
      image={image}
      onDismiss={handleBackgroundDismiss}
    >
      <p>
        Are you sure you don&apos;t want to get notified when these are in
        stock?
      </p>
      <AuthPanel>
        <Tracked.Button
          variant="forest"
          className={authButtonClassName}
          onClick={onGoBack}
          name="I_WANT_NOTIFICATIONS"
          pagePosition="Cancel modal"
        >
          I want notifications
        </Tracked.Button>
        <Tracked.Button
          variant="white"
          className={authButtonClassName}
          onClick={onCancel}
          name="CANCEL_NOTIFICATIONS"
          pagePosition="Cancel modal"
        >
          Cancel notifications
        </Tracked.Button>
      </AuthPanel>
    </ExitNotificationDialog>
  );
}
